import { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import NavBar from "../Components/NavBar/NavBar";
import TestimonialSection from "../Components/Shared/Testimonials";
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import Footer from "../Components/Footer/Footer";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

const HomePage = () => {

  const products = [{
    image: 'https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c21hcnRwaG9uZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60',
    title: 'Smartphones',
    desc: 'Flagship models with 0% EMI',
    count: '120+ Models',
  },
  {
    image: 'https://images.unsplash.com/photo-1593642632823-8f785ba67e45?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8bGFwdG9wfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60',
    title: 'Laptops',
    desc: 'For work, gaming, and creativity',
    count: '80+ Brands',
  },
  {
    image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8aGVhZHBob25lc3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60',
    title: 'Accessories',
    desc: 'Enhance your tech experience',
    count: '200+ Options',
  }]

  const product = [
    {
      id: 1,
      title: "Smartphone X",
      image: "https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?w=500&auto=format&fit=crop&q=60",
      price: "5,999"
    },
    {
      id: 2,
      title: "Wireless Earbuds",
      image: "https://images.unsplash.com/photo-1572569511254-d8f925fe2cbb?w=500&auto=format&fit=crop&q=60",
      price: "599"
    },
    {
      id: 3,
      title: "Ultra HD TV",
      image: "https://images.unsplash.com/photo-1542751110-97427bbecf20?w=500&auto=format&fit=crop&q=60",
      price: "499"
    },
    {
      id: 4,
      title: "Laptop Pro",
      image: "https://images.unsplash.com/photo-1593642632823-8f785ba67e45?w=500&auto=format&fit=crop&q=60",
      price: "999"
    },
    {
      id: 5,
      title: "Smart Watch",
      image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&auto=format&fit=crop&q=60",
      price: "129"
    },
    {
      id: 6,
      title: "Bluetooth Speaker",
      image: "https://images.unsplash.com/photo-1572569511254-d8f925fe2cbb?w=500&auto=format&fit=crop&q=60",
      price: "849"
    }
  ];

  const messages = [
    {
      text: "🎊 Limited deals! Get 12 months 0% EMI",
      highlight: "0% EMI",
      color: "text-danger"
    },
    {
      text: "✨ Flash Sale! Extra $150 cashback",
      highlight: "$150 cashback",
      color: "text-success"
    },
    {
      text: "🔥 Today Only! Free delivery",
      highlight: "Free delivery",
      color: "text-warning"
    }
  ];

  const [currentMessage, setCurrentMessage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessage((prev) => (prev + 1) % messages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [messages.length]);

  const parts = messages[currentMessage].text.split(messages[currentMessage].highlight);

  return (
    <div>
      <Helmet>
        <title>Home</title>
      </Helmet>
      <NavBar />
      <main>
        <section className="bg-light">
          <Container>
            <Row className="align-items-centerr">
              <Col lg={12}>
                <div className="text-center py-2 bg-light rounded">
                  <Col lg={12}>
                    <div className="text-center py-2 bg-light rounded">
                      <h2 className="text-dark m-0 d-flex align-items-center justify-content-center" style={{ fontSize: '14px' }}>
                        <span className="me-1">{parts[0]}</span>
                        <span className={`${messages[currentMessage].color} me-1`}>
                          {messages[currentMessage].highlight}
                        </span>
                        <span className="me-1">{parts[1]}</span>
                        <Button
                          as={Link}
                          to="/products"
                          variant="link"
                          className="text-primary p-0 text-decoration-none"
                          style={{ fontSize: '14px' }}
                        >
                          Shop Now →
                        </Button>
                      </h2>
                    </div>
                  </Col>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="bg-white py-5 mb-lg-5">
          <Container>
            <Row className="align-items-center g-5">
              <Col lg={6}>
                <div>
                  <h1 className="display-5 fw-bold text-dark mb-3">
                    Store. <span className="text-black-50">The best way to buy the products you love.</span>
                  </h1>

                  <div className="d-flex gap-3">
                    <Button as={Link} to="/sign-up" variant="dark" className="rounded-pill px-4 fw-bold shadow">
                      Get Started
                    </Button>
                    <Button
                      onClick={() =>
                        document.getElementById("learn-more").scrollIntoView({ behavior: "smooth" })
                      }
                      variant="outline-secondary"
                      className="rounded-pill px-4 fw-bold"
                    >
                      Learn More
                    </Button>
                  </div>
                </div>
              </Col>

              <Col lg={6}>
                <Swiper
                  effect={'coverflow'}
                  grabCursor={true}
                  centeredSlides={true}
                  slidesPerView={'auto'}
                  loop={true}
                  autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                  }}
                  coverflowEffect={{
                    rotate: 0,
                    stretch: 0,
                    depth: 100,
                    modifier: 2,
                    slideShadows: false,
                  }}
                  modules={[EffectCoverflow, Autoplay]}
                  className="product-swiper"
                  style={{
                    width: '100%',
                    maxWidth: '600px',
                    margin: '0 auto'
                  }}
                >
                  {product.map((product) => (
                    <SwiperSlide
                      key={product.id}
                      style={{
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        width: '250px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transform: 'scale(0.8)',
                        transition: 'transform 0.3s ease',
                      }}
                    >
                      <div className="rounded-4 m-3 bg-light h-100 hover-shadow transition w-100 h-100 d-flex flex-column">
                        <div className="ratio ratio-1x1 mb-3">
                          <img
                            src={product.image}
                            alt={product.title}
                            className="img-fluid rounded-3 object-fit-cover"
                          />
                        </div>
                        <h3 className="h5 text-dark text-center mb-1">{product.title}</h3>
                        {/* <div className="text-primary fw-bold text-center">{product.price}</div> */}
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="py-5 bg-light">
          <Container>
            <div className="py-4 py-md-5">
              <div
                className="text-center px-4 px-md-5 mx-auto"
                style={{ maxWidth: '720px' }}
              >
                <h2 className="fw-bold mb-3 lh-sm display-5">
                  Hassle-Free EMI Shopping Awaits You!
                </h2>
                <p className="text-secondary mb-4 fs-6">
                  No paperwork. No hidden charges. Just choose your product, pick
                  EMI, and relax — all with DBS Bank's trusted support.
                </p>
                <div className="text-center mb-5">
                  <Button
                    as={Link}
                    to="/products"
                    variant="dark"
                    className="rounded-pill btn-sm btn-md btn-lg btn-xl btn-xxl px-3 px-sm-4 px-md-5 py-2"
                    style={{ transition: 'all 0.3s ease-in-out' }}
                  >
                    Explore Products →
                  </Button>
                </div>
              </div>

              <div className="mt-5">
                <h3 className="text-center fw-bold text-decoration-underline mb-5 display-8">Featured Categories</h3>
                <Row className="g-4 g-lg-5 justify-content-center">
                  {products.map((item, index) => (
                    <Col key={index} xs={12} md={6} lg={4}>
                      <div className="card border-0 rounded-4 overflow-hidden h-100 shadow-sm hover-shadow-lg transition-all">
                        <div className="ratio ratio-16x9 bg-light">
                          <img
                            src={item.image}
                            alt={item.title}
                            className="object-fit-cover"
                            loading="lazy"
                          />
                        </div>
                        <div className="card-body p-4">
                          <div className="">
                            <div className="d-flex justify-content-between align-items-start">
                              <h4 className="fw-bold mb-2">{item.title}</h4>
                              <span className="badge bg-primary bg-opacity-10 text-primary fs-6">
                                {item.count}
                              </span>
                            </div>
                            <p className="text-muted mb-3">{item.desc}</p>
                          </div>
                          <Button
                            variant="outline-dark"
                            size="sm"
                            className="rounded-pill px-3 stretched-link"
                            as={Link}
                            to="/products"
                          >
                            Shop Now
                          </Button>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>

              <div className="pt-5">
                {/* <h3 className="text-center text-success fw-bold mb-4">Why Choose Us?</h3> */}
                <Row className="g-3">
                  {[
                    'DBS-backed secure EMI payments',
                    'Instant approval, no paperwork',
                    '0% interest on select products',
                    'Mobile-friendly management',
                  ].map((item, index) => (
                    <Col key={index} sm={6} md={3}>
                      <div className="d-flex align-items-center bg-white rounded-3 p-3 h-100">
                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                        <span className="small">{item}</span>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          </Container>
        </section>

        <section className="s-emi bg-light py-md-5" id="learn-more">
          <Container
            className="text-center py-5"
            style={{ maxWidth: '900px' }}
          >
            <div
              className="d-inline-flex align-items-center justify-content-center bg-success text-white rounded-circle mb-5"
              style={{ width: '60px', height: '60px' }}
            >
              <i className="bi bi-quote fs-3"></i>
            </div>

            <p className="fs-3 fs-md-1 fw-medium text-dark mb-4">
              “Why choose{' '}
              <span className="bg-success text-white rounded px-2 py-1">
                EMI with AZZ ?
              </span>{' '}
              Because it builds trust, enhances efficiency, showcases strong
              partnerships, and drives real-time user engagement to elevate your
              business success.”
            </p>

            <p className="text-muted mb-0">
              <span className="text-dark fw-bold">His/Her Name,</span>{' '}
              Chief Strategy Officer, AZZ
            </p>
          </Container>
        </section>

        <section className="bg-success text-white py-5">
          <Container className="text-center">
            <Row className="align-items-center justify-content-center">
              <Col md={10}>
                <h2 className="fw-bold mb-3">
                  Seamless EMI Integration with DBS Bank
                </h2>
                <p className="lead mb-4">
                  Enjoy quick approvals, zero hidden charges, and flexible monthly
                  payments powered by DBS.
                </p>
                <Button
                  as={Link}
                  to="/sign-up"
                  variant="light"
                  className="rounded-pill fw-semibold btn-sm btn-md btn-lg btn-xl btn-xxl px-3 px-sm-4 px-md-5 py-2"
                >
                  Register
                </Button>
              </Col>
            </Row>
          </Container>
        </section>

        <section
          className="s-testimonials  py-5 my-md-5"
        >
          <Container>
            <h3 className="mb-5 text-center fw-bold">
              Real Stories from Happy Customers
            </h3>
            <Row className="g-4">
              {/* Testimonial 1 */}
              <Col xs={12} md={6} lg={4}>
                <Card className="testimonial-card border-0 rounded-4 shadow-sm p-4 h-100">
                  <div className="d-flex align-items-center mb-3">
                    <img
                      src="https://randomuser.me/api/portraits/women/44.jpg"
                      alt="Alice Johnson"
                      className="rounded-circle me-3"
                      width="50"
                      height="50"
                    />
                    <div>
                      <p className="fw-semibold mb-0">Johnson</p>
                      <p className="text-muted small mb-0">CEO</p>
                    </div>
                  </div>
                  <p
                    className="fst-italic text-body-secondary fs-6"
                    style={{ lineHeight: 1.5 }}
                  >
                    “Partnering with DBS has transformed our financial operations.
                    The EMI benefits have streamlined our processes and built trust
                    with our clients.”
                  </p>
                </Card>
              </Col>

              {/* Testimonial 2 */}
              <Col xs={12} md={6} lg={4}>
                <Card className="testimonial-card border-0 rounded-4 shadow-sm p-4 h-100">
                  <div className="d-flex align-items-center mb-3">
                    <img
                      src="https://randomuser.me/api/portraits/men/32.jpg"
                      alt="Michael Smith"
                      className="rounded-circle me-3"
                      width="50"
                      height="50"
                    />
                    <div>
                      <p className="fw-semibold mb-0">Michael</p>
                      <p className="text-muted small mb-0">Researcher</p>
                    </div>
                  </div>
                  <p
                    className="fst-italic text-body-secondary fs-6"
                    style={{ lineHeight: 1.5 }}
                  >
                    “The EMI solutions provided by DBS have significantly improved
                    our cash flow management, allowing us to focus on growth and
                    customer satisfaction.”
                  </p>
                </Card>
              </Col>

              {/* Testimonial 3 */}
              <Col xs={12} md={6} lg={4}>
                <Card className="testimonial-card border-0 rounded-4 shadow-sm p-4 h-100">
                  <div className="d-flex align-items-center mb-3">
                    <img
                      src="https://randomuser.me/api/portraits/women/65.jpg"
                      alt="Rachel Lee"
                      className="rounded-circle me-3"
                      width="50"
                      height="50"
                    />
                    <div>
                      <p className="fw-semibold mb-0">Rook Lee</p>
                      <p className="text-muted small mb-0">Marketing Director</p>
                    </div>
                  </div>
                  <p
                    className="fst-italic text-body-secondary fs-6"
                    style={{ lineHeight: 1.5 }}
                  >
                    “With DBS's support, we have enhanced our user engagement
                    strategies, leveraging EMI benefits to foster deeper connections
                    with our customers.”
                  </p>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        <TestimonialSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;